import React from "react";
import { EyeIcon, EyeCrossedIcon } from "@aureskonnect/react-ui";

type PaymentFieldProps = {
    label: string;
    value: string;
    onChange: (v: string) => void;
    isPassword?: boolean;
    showPassword?: boolean;
    toggleShowPassword?: () => void;
    testId?: string;
};

export function PaymentField({
    label,
    value,
    onChange,
    isPassword,
    showPassword,
    toggleShowPassword,
    testId,
}: PaymentFieldProps) {
    return (
        <div data-testid={testId ? `${testId}-field` : undefined}>
            <label className="payment-field-label__clz">{label}</label>
            <div className="payment-field-wrapper__clz">
                <input
                    data-testid={testId ? `${testId}-input` : undefined}
                    className={
                        isPassword
                            ? "payment-field-input__clz payment-field-input--password__clz"
                            : "payment-field-input__clz"
                    }
                    type={isPassword && !showPassword ? "password" : "text"}
                    autoComplete={isPassword ? "new-password" : "off"}
                    maxLength={128}
                    value={value}
                    onChange={(e) => onChange(e.target.value)}
                />
                {isPassword && toggleShowPassword && (
                    <div
                        data-testid={testId ? `${testId}-toggle` : undefined}
                        className="payment-field-toggle__clz"
                        onClick={toggleShowPassword}
                    >
                        {showPassword ? (
                            <EyeCrossedIcon height={18} width={18} />
                        ) : (
                            <EyeIcon height={18} width={18} />
                        )}
                    </div>
                )}
            </div>
        </div>
    );
}
